// v1 ARCHIVE FLAG.
//
// This constant is `true` only on the long-lived `v1` branch, which builds the
// frozen static snapshot deployed to v1.cosx.co. That deployment has no /api
// backend (no D1/KV/R2, no Pages Functions), so anything that would hit the
// network must be short-circuited:
//   - contact / subscribe forms show an archive notice instead of POSTing
//   - the insights loader skips its on-mount /api/insights refresh
//
// On `main` this is hardcoded false; the value is intentionally divergent
// between branches rather than env-driven, so the archive can never ship with
// live endpoints by accident.
export const IS_ARCHIVE = true;

// Where to send people who try to use a disabled feature on the archive.
export const LIVE_SITE_URL = "https://cosx.co";
